import { useEffect, useState } from 'react';

/** The current time, re-read every `ms` (faster while a countdown is running in seconds). */
export function useNow(ms = 30000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(id);
  }, [ms]);
  return now;
}

/** True while any of these start times is inside six minutes, i.e. a countdown should tick each second. */
export const anyWithinSixMinutes = (times: (string | null | undefined)[]): boolean =>
  times.some((t) => t != null && Date.parse(t) - Date.now() < 360000);
